import { WebSpeechTtsSynthesizer } from "@colibrio/colibrio-reader-framework/colibrio-readingsystem-engine";
import type { ICirrusTtsServiceProvider } from "./CirrusReaderModel";
import type { ISpeechSynthesisVoiceCollection } from '../utils/WebSpeechUtils';
import { useWebSpeechUtils } from '../utils/WebSpeechUtils';

export class CirrusReaderWebSpeechTtsSynthesizer extends WebSpeechTtsSynthesizer implements ICirrusTtsServiceProvider {
    private _activeVoice: SpeechSynthesisVoice | undefined;
    private _ttsVoiceCollection: ISpeechSynthesisVoiceCollection | undefined;

    get supportsWordBoundaries(): boolean {
        return true;
    }

    setActiveVoice(voice: SpeechSynthesisVoice): void {
        const voiceName = voice.name;
        this._activeVoice = this._ttsVoiceCollection?.allVoices.find(voice => voice.name === voiceName);
    }

    getActiveVoice(): SpeechSynthesisVoice | undefined {
        return this._activeVoice;
    }

    async fetchVoices(): Promise<ISpeechSynthesisVoiceCollection | undefined> {

        if(this._ttsVoiceCollection) {
            return Promise.resolve(this._ttsVoiceCollection);
        }

        this._ttsVoiceCollection = await useWebSpeechUtils().fetchTtsVoices();
        return this._ttsVoiceCollection;
    }
}
